module.exports = "/build/web/svg/download.b00d52a5cc473f8b645b9c17a1213971.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/download.svg
// module id = 96
// module chunks = 24